import { ApplicationConfig, ErrorHandler, inject, Injectable, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { loaderInterceptor } from './interceptor/loader-interceptor.interceptor';
import { AlertService } from './shared/services/alert.service';
import { extractError } from './shared/AwaitableObservable';


@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  private alertService = inject(AlertService);

  handleError(e: any): void {
    const error = extractError(e);
    // не выводить ошибку `NG0100: ExpressionChangedAfterItHasBeenCheckedError: Expression has changed after it was checked.`
    if (!error.startsWith('NG0100: ')) {
      this.alertService.handleError(error);
    }
    throw e;
  }
}


export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler }, 

    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([loaderInterceptor])),
    provideAnimations(),
  ],
};
